import { render, staticRenderFns } from "./webscoket.vue?vue&type=template&id=daa38dee"
import script from "./webscoket.vue?vue&type=script&lang=js"
export * from "./webscoket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('daa38dee')) {
      api.createRecord('daa38dee', component.options)
    } else {
      api.reload('daa38dee', component.options)
    }
    module.hot.accept("./webscoket.vue?vue&type=template&id=daa38dee", function () {
      api.rerender('daa38dee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/webscoket/webscoket.vue"
export default component.exports